export default {
    en: {
        LIBRARY_ENTRY_SETTINGS_IS_DEFAULT_CHALLENGE: 'Default challenge',
        LIBRARY_ENTRY_SETTINGS_MAX_NUMBER_OF_ATTEMPTS: 'Max number of attempts'
    }
};
